module.exports = __webpack_public_path__ + "img/records-icon.504e18cf.svg";